module.exports = __webpack_public_path__ + "media/images/gn_icon01-f7a7a3f79a022a6470a11ed5112362f3.png";